import React, { useState, useEffect } from 'react';
import GoalService from './GoalService';
import Alert from 'react-bootstrap/Alert';
import filterFieldsForList from '../../common/functions/filterFieldsForList';
import schema from './jsonSchema';
import useHeaderGenerator from 'components/app/common/functions/useHeaderGenerator';
import useTableGenerator from '../../common/functions/useTableGenerator';
import { useNavigate } from 'react-router-dom';
import DirectoryService from 'components/app/directory/DirectoryService';
const WODGoalTable = () => {
    const navigate = useNavigate();
  const [columns, setColumns] = useState([]);
  const [error, setError] = useState('');
  const [noDataToShow, setNoDataToShow] = useState(true);
  const [tableGenerated, setTableGenerated] = useState();
  const [refreshList, setRefreshList] = useState(false);

  const convertTime = time => {
    const date = new Date(time);
    return date.toLocaleDateString();
  };

  const deleteGoal = identification => {
    GoalService.deleteGoal(identification)
      .then(response => {
        console.log(response);
      })
      .catch(error => console.log(error));
  };

  const jsonSchema = schema;

  useEffect(() => {
    const fieldsForList = filterFieldsForList(jsonSchema);
    setColumns(fieldsForList);

    GoalService.retrieveAllGoalByAccount()
      .then(data => {
        const updatedData = data;

        const actionButtons = [
          {
            icon: 'edit',
            onClick: identifier => {
              navigate('/app/wod/goals/' + identifier);
            },
            className: 'p-0',
            title: 'Edit',
            variant: 'action'
          }
        ];
        if (DirectoryService.isLoggedUserRoot()) {
          actionButtons.push({
            icon: 'trash-alt',
            onClick: identifier => {
              deleteGoal(identifier);
              setRefreshList(true);
            },
            className: 'p-0',
            title: 'Delete',
            variant: 'action'
          });
        }  
        setNoDataToShow(updatedData.length === 0);
        setTableGenerated(useTableGenerator(updatedData, jsonSchema, actionButtons));
        setRefreshList(false);
      })
      .catch(error => setError(error.message));
  }, [refreshList]);

  const buttonsConf = [
       {
      name: 'Add Goal',
      icon: 'plus',
      type: 'button',
      variant: 'info',
      onClick: () => {
        navigate('/app/wod/goals/create-form');
      }
    },
  ];
  const headerGenerated = useHeaderGenerator('Goals', ' ', buttonsConf);

  return (
    <>
      {error}
      {headerGenerated}
      {noDataToShow && (
        <Alert key="warning" variant="warning">
          There's not any Goal to show.
        </Alert>
      )}
      {tableGenerated}
    </>
  );
};

export default WODGoalTable;